var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18.75,
    viewBox: "0 0 25 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0 -58.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grip-solid-horizontal_1_",
    transform: "translate(0 58.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M23.437,351.354H1.563a1.6,1.6,0,0,1,0-3.2H23.437a1.6,1.6,0,0,1,0,3.2Z",
    transform: "translate(0 -332.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M23.437,206.29H1.563a1.6,1.6,0,0,1,0-3.2H23.437a1.6,1.6,0,0,1,0,3.2Z",
    transform: "translate(0 -195.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M23.437,61.225H1.563a1.6,1.6,0,0,1,0-3.2H23.437a1.6,1.6,0,0,1,0,3.2Z",
    transform: "translate(0 -58.025)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.88ec7be2eeef1cadefb3e4f79a561311.svg";
export { ForwardRef as ReactComponent };